export const areAnalyticsEnabled = (): boolean => {
    return !!import.meta.env.VITE_MATOMO_SRC;
};

export const setCustomDimension = (values: Record<string, string | number>): void => {
    const mtm = globalThis._mtm;
    if (!areAnalyticsEnabled() || !mtm) return;

    mtm.push({
        event: 'userContext',
        ...values,
    });
};
